import {
  NauticalShipBoxComponent,
  UiCustomComponent,
  UiCustomComponents,
} from '@seahorse/temp';

export const uiModuleCustomComponents: UiCustomComponents = [
  <UiCustomComponent<NauticalShipBoxComponent>>{
    key: '$nautical_ship',
    type: 'linkedObjectCard',
    component: NauticalShipBoxComponent,
    data: (title, id, displayFields) => ({
      title,
      shipId: id,
      displayFields,
    }),
  },
];
